export default class Locale_PickerFields {
	ItemTitle: string = "Item title";
	ItemSecondaryText: string = "Item secondary text";
	ItemTertiaryText: string = "Item tertiary text";
	ItemQuarternaryText: string = "Item quaternary text - same line as tertiary";
	ItemIconText: string = "Item icon text";
}